import _ from 'lodash';
import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getSelectorBasedStoreValue } from 'v2/modules/withRunForm/redux/selector';
import { RUN_TYPES, ORDER_TYPES } from 'v2/common/constants/index';
import RunFormInstructions from 'ui/run/RunForm/components/RunFormInstructions';
import RunType from './RunType';
import OrderType from 'v3/common/components/OrderType';
import RunName from './RunName';
import Folder from './Folder';
import GranularitySelector from './GranularitySelector';
import DateRange from 'v3/common/components/DatePicker/DateRange';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const RunFormHeader = () => {
  const runType = useSelector((state) => getSelectorBasedStoreValue(state, 'runType'));
  const orderType = useSelector((state) => getSelectorBasedStoreValue(state, 'orderType'));
  const isLive = useMemo(() => runType === RUN_TYPES.live, [runType]);
   const {isAdmin, eligibleOrderType} = ApplicationDomainUtility;
  const isSecondBySecondEnabledForUser =
    _.get(window, 'SA_FEATURE_FLAGS.isRunGranularitySecondEnabled', false) || isAdmin;

  const shouldShowGranularity = !isLive && isSecondBySecondEnabledForUser;

  const {
    paper: { value: paper },
  } = ORDER_TYPES;
  const isActualOrder = useMemo(() => orderType !== paper && isLive, [orderType, paper, isLive]);

  return (
    <>
      <div className="card-wrapper  position-relative">
        <RunType />

        <div className="row run-configuration">
          {isLive ? (
            _.size(eligibleOrderType()) > 1 && (
              <div className="col-sm">
                <OrderType />
              </div>
            )
          ) : (
            <>
              <div className="col-sm">
                <DateRange />
              </div>
            </>
          )}
          <div className="col-sm">
            <RunName />
          </div>
          <div className="col-sm">
            <Folder />
          </div>
          {shouldShowGranularity && (
            <div className="col-sm ">
              <GranularitySelector />
            </div>
          )}
        </div>
      </div>
      {isActualOrder && !ApplicationDomainUtility.isCrypto && <RunFormInstructions orderType={orderType} />}
    </>
  );
};

export default memo(RunFormHeader);
